import React, { Fragment } from 'react'
import Img1 from "../../images/product.png"
import Img2 from "../../images/purchase-order.png"
import Img3 from "../../images/commission.png"
import { formatNumberShort } from '../../../utils/formatNumberShort'

const TopBarValues = ({ totalProducts, totalorders, overallComission }) => {





    return (
        <Fragment>
            <div className="flex justify-center gap-[1vmax] lg:gap-[2vmax] mb-[1vmax] flex-wrap">
                <div className="w-[48%] lg:w-[25%] flex bg-white p-[1vmax] shadow-1 rounded-lg">
                    <div className="w-[70%] flex justify-between flex-col gap-[1vmax]">
                        <span className="text-[2vmax] font-3 font-[700] text-gray-600" >{totalProducts || 0}</span>
                        <span className="text-gray-600  uppercase text-[1vmax]" >Total Products</span>
                    </div>
                    <div className="w-[30%] flex justify-end items-center">
                        <div className="w-[3vmax] h-[3vmax] bg-green-500 rounded-full grid place-items-center">
                            <img src={Img1} alt="" className='w-[1.8vmax]' />
                        </div>
                    </div>
                </div>
                <div className="w-[48%] lg:w-[25%] flex bg-white p-[1vmax] shadow-1 rounded-lg">
                    <div className="w-[70%] flex justify-between flex-col gap-[1vmax]">
                        <span className="text-[2vmax] font-3 font-[700] text-gray-600" >Rs.&nbsp;
                            {formatNumberShort(overallComission || 0)}
                        </span>
                        <span className="text-gray-600  uppercase text-[1vmax]" >Commission Potential</span>
                    </div>
                    <div className="w-[30%] flex justify-end items-center">
                        <div className="w-[3vmax] h-[3vmax] bg-pink-500 rounded-full grid place-items-center">
                            <img src={Img2} alt="" className='w-[1.8vmax]' />
                        </div>
                    </div>
                </div>
                <div className="w-[48%] lg:w-[25%] flex bg-white p-[1vmax] shadow-1 rounded-lg">
                    <div className="w-[70%] flex justify-between flex-col gap-[1vmax]">
                        <span className="text-[2vmax] font-3 font-[700] text-gray-600" >{totalorders || 0}</span>
                        <span className="text-gray-600 uppercase text-[1vmax]" >Today’s Orders Left</span>
                    </div>
                    <div className="w-[30%] flex justify-end items-center">
                        <div className="w-[3vmax] h-[3vmax] bg-orange-400 rounded-full grid place-items-center">
                            <img src={Img3} alt="" className='w-[1.8vmax]' />
                        </div>
                    </div>
                </div>
            </div>
        </Fragment>
    )
}

export default TopBarValues
